// @type
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import type { FileType } from './../types/file';

import Text from './shared/Typography';
import Card from './shared/Card';
import Icon from './shared/Icon';
import FilePreview from './shared/FilePreview';
import { getRouteTFunction } from '../i18n';

type Props = {
  file: FileType,
  recordID: number,
  accessToken?: string, // for shared records
  token?: String, // for shared records
  openFile?: () => void // for shared records
}

const FileIcon = (file) => {
  if (file.mime_type === 'image/png'
  || file.mime_type === 'image/jpeg'
  || file.mime_type === 'image/gif') {
    return <Icon className='thumbnail' name='img' size='x-large' />;
  } else if (file.mime_type === 'application/pdf') {
    return <Icon className='thumbnail' name='pdf' size='x-large' />;
  }
  return null;
};

const ResourceFileCard = ({ file, recordID, token, openFile }: Props) => {
  const { t } = useTranslation('resourceFileCard');
  const routesTFunction = getRouteTFunction();

  return (
    <Card noPadding noShadow className='record-file__card' key={file.id}>
      <FilePreview
        token={token}
        fileID={file.id}
        key={file.id}
        recordID={recordID}
      />
      <div className='record-file__card__sub-container'>
        {FileIcon(file)}
        <div className='record-file__card__sub-container__content'>
          <Text paragraph bold>
            {file.file_name}
          </Text>
          {token ?
            // if this is a shared record
            <Link
              className='record-file__link mid-grey is-left'
              to={{
              pathname: routesTFunction('redirectPaths./shared/:token/resource/:id/file/:fileID',
                                          { token, id: recordID, fileID: file.id }),
              state: {
                fileID: file.id,
                recordID: recordID,
                token: token
              } }}
              onClick={() => openFile(file.id, recordID)}
            >
              {t('view_file')}
            </Link>
            : // if this is not a shared record
            <Link
              className='record-file__link  mid-gray is-left'
              to={{
                pathname: routesTFunction('redirectPaths./resource/:id/resource-files/:file_id',
                                            { id: recordID, file_id: file.id }),
                state: {
                  file: file
                }
              }}
            >
              {t('view_file')}
            </Link>}
        </div>
      </div>
    </Card>
  );
};

export default ResourceFileCard;



// WEBPACK FOOTER //
// ./src/components/resource-file-card.js